module.exports = __webpack_public_path__ + "static/media/Medcare Medical Centre Jumeirah.95b1b4c8.jpg";